(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m360-binocular-angle-viewer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-m360-angle]:not([data-angle-ready])').forEach((viewer) => {
    viewer.dataset.angleReady = 'true';
    const stage = viewer.querySelector('.m360-angle__stage');
    const frames = Array.from(viewer.querySelectorAll('[data-angle-frame]'));
    const counter = viewer.querySelector('[data-angle-counter]');
    let index = 0;
    let dragging = false;
    let startX = 0;
    let startIndex = 0;

    const show = (next) => {
      index = (next + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        const active = frameIndex === index;
        frame.classList.toggle('is-hidden', !active);
        frame.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      counter.value = `${index + 1} / ${frames.length}`;
      counter.textContent = counter.value;
    };

    stage.addEventListener('pointerdown', (event) => {
      dragging = true;
      startX = event.clientX;
      startIndex = index;
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const pixelsPerFrame = Math.max(34, stage.clientWidth / frames.length);
      show(startIndex + Math.round((event.clientX - startX) / pixelsPerFrame));
    });
    const stop = (event) => {
      dragging = false;
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };
    stage.addEventListener('pointerup', stop);
    stage.addEventListener('pointercancel', stop);
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m360-home-rails-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const requests = new Map();
  const pending = [];
  let running = 0;

  function schedule(task) {
    pending.push(task);
    pump();
  }

  function pump() {
    while (running < 2 && pending.length) {
      running++;
      pending.shift()().catch(() => {}).finally(() => { running--; pump(); });
    }
  }

  function requestPage(url) {
    if (!requests.has(url.href)) {
      const task = (async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url.href, {credentials: 'same-origin', signal: controller.signal});
          if (!response.ok) throw new Error('Collection response unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = document.querySelector('[data-home-feed]');
          if (!feed) throw new Error('Collection section unavailable');
          return feed;
        } finally { clearTimeout(timeout); }
      })();
      requests.set(url.href, task);
    }
    return requests.get(url.href);
  }

  function feedURL(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid collection origin');
    url.searchParams.set('section_id', 'm360-home-feed');
    url.searchParams.set('sort_by', 'created-desc');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url;
  }

  async function completeRail(rail) {
    const limit = Math.min(16, Number(rail.dataset.limit) || 16);
    const grid = rail.querySelector('.m360-products');
    const mode = rail.dataset.mode === 'special' ? 'special' : 'available';
    const vendor = rail.dataset.vendor;
    const cards = new Map();
    const visited = new Set();
    let url = feedURL(rail.dataset.collectionUrl);
    rail.setAttribute('aria-busy', 'true');
    try {
      while (url && cards.size < limit) {
        if (visited.has(url.href)) throw new Error('Repeated pagination');
        visited.add(url.href);
        const feed = await requestPage(url);
        feed.querySelectorAll('.m360-product[data-product-id]').forEach(card => {
          if (cards.size < limit && card.dataset.productState === mode && card.dataset.vendor === vendor) {
            cards.set(card.dataset.productId, card.cloneNode(true));
          }
        });
        url = feed.dataset.nextUrl ? feedURL(feed.dataset.nextUrl) : null;
      }
      if (!rail.isConnected) return;
      grid.replaceChildren(...cards.values());
      rail.hidden = cards.size === 0;
      rail.dataset.railLoaded = 'true';
    } catch {
      rail.dataset.railLoaded = 'fallback';
    } finally { rail.removeAttribute('aria-busy'); }
  }

  function init() {
    document.querySelectorAll('[data-home-rail]').forEach(rail => {
      if (initialized.has(rail)) return;
      initialized.add(rail);
      if (!rail.hasAttribute('data-newest') && Number(rail.dataset.productCount) <= 250) return;
      schedule(() => completeRail(rail));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m360-product-spin"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-m360-spin]:not([data-spin-ready])').forEach((viewer) => {
    viewer.dataset.spinReady = 'true';
    const stage = viewer.querySelector('.m360-spin__stage');
    const frames = Array.from(viewer.querySelectorAll('[data-spin-frame]'));
    const counter = viewer.querySelector('[data-spin-counter]');
    let index = 0;
    let dragging = false;
    let startX = 0;
    let startIndex = 0;

    const show = (next) => {
      index = (next + frames.length) % frames.length;
      frames.forEach((frame, frameIndex) => {
        const active = frameIndex === index;
        frame.classList.toggle('is-hidden', !active);
        frame.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      counter.value = `${index + 1} / ${frames.length}`;
      counter.textContent = counter.value;
    };

    stage.addEventListener('pointerdown', (event) => {
      dragging = true;
      startX = event.clientX;
      startIndex = index;
      stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const pixelsPerFrame = Math.max(24, stage.clientWidth / frames.length);
      show(startIndex + Math.round((event.clientX - startX) / pixelsPerFrame));
    });
    const stop = (event) => {
      dragging = false;
      if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
    };
    stage.addEventListener('pointerup', stop);
    stage.addEventListener('pointercancel', stop);
    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m360v02-demo-catalog"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-m360-demo]').forEach((demo) => {
      if (demo.dataset.demoReady) return;
      demo.dataset.demoReady = 'true';
      const dialog = demo.querySelector('dialog');
      const title = demo.querySelector('[data-demo-dialog-title]');
      const content = demo.querySelector('[data-demo-dialog-content]');
      let opener;
      demo.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-m360-demo-open]');
        if (trigger && demo.contains(trigger)) {
          const template = document.getElementById(trigger.dataset.m360DemoOpen);
          if (!template || !demo.contains(template)) return;
          opener = trigger;
          title.textContent = template.dataset.demoTitle;
          content.replaceChildren(template.content.cloneNode(true));
          dialog.showModal();
          dialog.querySelector('[data-demo-close]').focus();
        }
        if (event.target.closest('[data-demo-close]')) dialog.close();
      });
      dialog.addEventListener('close', () => opener?.focus());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m360v02-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-m360v02-carousel]').forEach((carousel) => {
      if (carousel.dataset.m360v02Ready) return;
      const track = carousel.querySelector('[data-m360v02-track]');
      const previous = carousel.querySelector('[data-m360v02-prev]');
      const next = carousel.querySelector('[data-m360v02-next]');
      if (!track || !previous || !next) return;
      carousel.dataset.m360v02Ready = 'true';
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = (direction) => {
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * (track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      carousel.addEventListener('m360v02:disconnect', () => observer.disconnect(), {once: true});
      update();
    });
    scope.querySelectorAll('.m360v02-nav__more').forEach((menu) => {
      if (menu.dataset.m360v02Ready) return;
      menu.dataset.m360v02Ready = 'true';
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
      menu.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-m360v02-carousel]').forEach((carousel) => carousel.dispatchEvent(new Event('m360v02:disconnect'))));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m360v4-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
    const runtimeKey = Symbol.for('360bosmx.v4.interactions');
    if (window[runtimeKey]) {
      window[runtimeKey]();
      return;
    }
    const storageKey = '360bosmx-v4-favorites';
    const recentKey = '360bosmx-v4-recent';
    const compareKey = '360bosmx-v4-compare';
    const initialized = new WeakSet();
    const controllers = new Map();
    let memory = [];
    let recentMemory = [];
    let compareMemory = [];
    let storageAvailable = true;

    const productURL = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !/\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname)) return '';
        return url.pathname + url.search;
      } catch {
        return '';
      }
    };

    const imageURL = (value) => {
      if (!value) return '';
      try {
        const url = new URL(value, window.location.origin);
        const hosted = url.origin === window.location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopifycdn.com');
        if (!hosted || !['https:', 'http:'].includes(url.protocol)) return '';
        return url.href;
      } catch {
        return '';
      }
    };

    const cleanItems = (items) => {
      if (!Array.isArray(items)) return [];
      const seen = new Set();
      return items.slice(0, 100).flatMap((item) => {
        if (!item || typeof item !== 'object') return [];
        const handle = typeof item.handle === 'string' ? item.handle.slice(0, 255) : '';
        const title = typeof item.title === 'string' ? item.title.slice(0, 500) : '';
        const url = typeof item.url === 'string' ? productURL(item.url) : '';
        if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle) || !title || !url || seen.has(handle)) return [];
        seen.add(handle);
        return [{ handle, title, url, image: imageURL(typeof item.image === 'string' ? item.image : '') }];
      });
    };

    const readSaved = () => {
      if (!storageAvailable) return memory;
      try {
        const raw = window.localStorage.getItem(storageKey);
        memory = cleanItems(raw ? JSON.parse(raw) : []);
      } catch {
        storageAvailable = false;
      }
      return memory;
    };

    const writeSaved = (items) => {
      memory = cleanItems(items);
      if (storageAvailable) {
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(memory));
        } catch {
          storageAvailable = false;
        }
      }
      syncAll();
    };

    const cleanHandles = (items) => Array.isArray(items)
      ? [...new Set(items.filter((handle) => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/i.test(handle)))].slice(0, 4)
      : [];

    const readSelection = () => {
      if (!storageAvailable) return;
      try {
        recentMemory = cleanItems(JSON.parse(window.localStorage.getItem(recentKey) || '[]')).slice(0, 12);
      } catch {
        recentMemory = [];
      }
      try {
        compareMemory = cleanHandles(JSON.parse(window.localStorage.getItem(compareKey) || '[]'));
      } catch {
        compareMemory = [];
      }
    };

    const writeSelection = (key, items) => {
      if (key === recentKey) recentMemory = cleanItems(items).slice(0, 12);
      else compareMemory = cleanHandles(items);
      if (storageAvailable) {
        try {
          window.localStorage.setItem(key, JSON.stringify(key === recentKey ? recentMemory : compareMemory));
        } catch {
          storageAvailable = false;
        }
      }
      syncAll();
    };

    const syncAll = () => {
      for (const [root, controller] of controllers) {
        if (!root.isConnected) {
          controller.dispose();
          controllers.delete(root);
        } else {
          controller.sync();
        }
      }
    };

    const initialize = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const dialog = root.querySelector('[data-m360v4-saved-dialog]');
      const savedList = root.querySelector('[data-m360v4-saved-list]');
      const announcer = root.querySelector('[data-m360v4-announcement]');
      const priceInput = root.querySelector('[data-m360v4-max-price]');
      const priceOutput = root.querySelector('[data-m360v4-price-output]');
      const availabilityInput = root.querySelector('[data-m360v4-available]');
      const sidebarDetails = root.querySelector('.m360v4-sidebar__details');
      const selection = root.querySelector('[data-m360v4-selection]');
      const compareDialog = selection?.querySelector('[data-m360v4-compare-dialog]');
      const compareChoices = selection?.querySelector('[data-m360v4-compare-choices]');
      const compareContent = selection?.querySelector('[data-m360v4-compare-content]');
      const compareStatus = selection?.querySelector('[data-m360v4-compare-status]');
      const recentList = selection?.querySelector('[data-m360v4-recent-list]');
      const aborter = new AbortController();
      const eventOptions = { signal: aborter.signal };
      if (sidebarDetails && typeof window.matchMedia === 'function') {
        const mobileViewport = window.matchMedia('(max-width:749px)');
        const updateSidebar = () => { sidebarDetails.open = !mobileViewport.matches; };
        updateSidebar();
        mobileViewport.addEventListener('change', updateSidebar, eventOptions);
      }
      let lastOpener;
      let compareOpener;
      let announcementTimer;
      let priceFormatter;
      try {
        priceFormatter = new Intl.NumberFormat(root.dataset.locale || document.documentElement.lang || 'es-MX', {
          style: 'currency',
          currency: root.dataset.currency || 'MXN',
          currencyDisplay: 'narrowSymbol',
          maximumFractionDigits: 2
        });
      } catch {
        priceFormatter = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
      }

      const label = (name) => root.dataset[name] || '';
      const announce = (message) => {
        if (!announcer || !message) return;
        clearTimeout(announcementTimer);
        announcer.textContent = '';
        announcementTimer = setTimeout(() => { announcer.textContent = message; }, 180);
      };

      const selectionLabel = (name) => selection?.dataset[name] || '';
      const catalog = new Map();
      root.querySelectorAll('[data-m360v4-card]').forEach((card) => {
        const saveButton = card.querySelector('[data-m360v4-save]');
        if (!saveButton) return;
        const [item] = cleanItems([saveButton.dataset]);
        if (!item || catalog.has(item.handle)) return;
        catalog.set(item.handle, {
          ...item,
          price: card.querySelector('.m360v4-card__price')?.textContent.trim() || '',
          vendor: card.dataset.vendor?.trim() || '',
          sku: (card.querySelector('.m360v4-card__sku')?.textContent.trim() || '').replace(/^SKU:\s*/i, ''),
          status: ['available', 'special'].includes(card.dataset.status) ? card.dataset.status : 'upcoming'
        });
      });

      const productLink = (item, size) => {
        const link = document.createElement('a');
        link.href = item.url;
        link.title = item.title;
        if (item.image) {
          const thumbnail = document.createElement('img');
          thumbnail.src = item.image;
          thumbnail.alt = '';
          thumbnail.width = size;
          thumbnail.height = size;
          thumbnail.loading = 'lazy';
          link.append(thumbnail);
        }
        const title = document.createElement('span');
        title.textContent = item.title;
        link.append(title);
        return link;
      };

      const renderRecent = () => {
        if (!recentList) return;
        const fragment = document.createDocumentFragment();
        recentMemory.slice(0, 4).forEach((item) => {
          const row = document.createElement('li');
          row.append(productLink(item, 96));
          fragment.append(row);
        });
        recentList.replaceChildren(fragment);
        selection.querySelector('[data-m360v4-recent-empty]').hidden = recentMemory.length > 0;
        selection.querySelector('[data-m360v4-clear-recent]').hidden = recentMemory.length === 0;
      };

      const selectedProducts = () => compareMemory.flatMap((handle) => catalog.has(handle) ? [catalog.get(handle)] : []);

      const renderComparison = () => {
        if (!compareContent) return;
        const selected = selectedProducts();
        compareStatus.textContent = selected.length < 2
          ? selectionLabel('compareEmpty')
          : selectionLabel('compareCount').replace('{count}', String(selected.length));
        compareContent.replaceChildren();
        if (!selected.length) return;
        const table = document.createElement('table');
        const header = document.createElement('thead');
        const headerRow = document.createElement('tr');
        const corner = document.createElement('td');
        headerRow.append(corner);
        selected.forEach((item) => {
          const cell = document.createElement('th');
          cell.scope = 'col';
          cell.append(productLink(item, 160));
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'm360v4-compare__remove';
          remove.dataset.m360v4RemoveCompare = item.handle;
          remove.textContent = selectionLabel('remove');
          remove.setAttribute('aria-label', `${selectionLabel('remove')}: ${item.title}`);
          cell.append(remove);
          headerRow.append(cell);
        });
        header.append(headerRow);
        const body = document.createElement('tbody');
        [['price', 'price'], ['brand', 'vendor'], ['sku', 'sku'], ['availability', 'status']].forEach(([labelKey, field]) => {
          const row = document.createElement('tr');
          const heading = document.createElement('th');
          heading.scope = 'row';
          heading.textContent = selectionLabel(labelKey);
          row.append(heading);
          selected.forEach((item) => {
            const cell = document.createElement('td');
            cell.textContent = field === 'status'
              ? selectionLabel(item.status)
              : item[field] || selectionLabel('notProvided');
            if (field === 'status') cell.className = `m360v4-compare__state m360v4-compare__state--${item.status}`;
            row.append(cell);
          });
          body.append(row);
        });
        table.append(header, body);
        compareContent.append(table);
      };

      if (compareChoices) {
        const fragment = document.createDocumentFragment();
        catalog.forEach((item) => {
          const choice = document.createElement('label');
          choice.className = 'm360v4-compare__choice';
          const input = document.createElement('input');
          input.type = 'checkbox';
          input.dataset.m360v4CompareHandle = item.handle;
          const title = document.createElement('span');
          title.textContent = item.title;
          title.title = item.title;
          choice.append(input, title);
          fragment.append(choice);
        });
        compareChoices.append(fragment);
      }

      const syncSelection = () => {
        if (!selection) return;
        const selected = selectedProducts();
        const handles = new Set(selected.map((item) => item.handle));
        selection.querySelectorAll('[data-m360v4-compare-count]').forEach((node) => {
          node.textContent = String(selected.length);
          node.hidden = !selected.length;
        });
        compareChoices?.querySelectorAll('[data-m360v4-compare-handle]').forEach((input) => {
          input.checked = handles.has(input.dataset.m360v4CompareHandle);
          input.disabled = !input.checked && selected.length >= 4;
        });
        renderRecent();
        if (compareDialog?.open) renderComparison();
      };

      const closeCompare = () => {
        if (!compareDialog) return;
        if (typeof compareDialog.close === 'function') compareDialog.close();
        else compareDialog.removeAttribute('open');
        if (compareOpener?.isConnected) compareOpener.focus();
      };

      const recordOpened = (event) => {
        if (!selection || event.defaultPrevented || !(event.target instanceof Element)) return;
        const anchor = event.target.closest('a[href]');
        if (!anchor || anchor.hasAttribute('download')) return;
        const url = productURL(anchor.href);
        if (!url) return;
        const handle = new URL(url, window.location.origin).pathname.split('/').filter(Boolean).at(-1);
        const item = catalog.get(handle) || recentMemory.find((saved) => saved.handle === handle);
        if (item) writeSelection(recentKey, [item, ...recentMemory.filter((saved) => saved.handle !== handle)]);
      };

      const renderSaved = () => {
        if (!savedList) return;
        const fragment = document.createDocumentFragment();
        if (!memory.length) {
          const empty = document.createElement('li');
          empty.className = 'm360v4-saved__empty';
          empty.textContent = label('savedEmpty') || dialog?.dataset.emptyLabel || '';
          fragment.append(empty);
        }
        for (const item of memory) {
          const row = document.createElement('li');
          row.className = 'm360v4-saved__item';
          const link = document.createElement('a');
          link.className = 'm360v4-saved__link';
          link.href = item.url;
          if (item.image) {
            const thumbnail = document.createElement('img');
            thumbnail.src = item.image;
            thumbnail.alt = '';
            thumbnail.width = 64;
            thumbnail.height = 64;
            thumbnail.loading = 'lazy';
            link.append(thumbnail);
          }
          const title = document.createElement('span');
          title.textContent = item.title;
          link.append(title);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'm360v4-saved__remove';
          remove.dataset.m360v4RemoveSaved = item.handle;
          remove.textContent = label('savedRemove');
          remove.setAttribute('aria-label', `${label('savedRemove')}: ${item.title}`);
          row.append(link, remove);
          fragment.append(row);
        }
        savedList.replaceChildren(fragment);
      };

      const sync = () => {
        const handles = new Set(memory.map((item) => item.handle));
        root.querySelectorAll('[data-m360v4-save]').forEach((button) => {
          button.setAttribute('aria-pressed', String(handles.has(button.dataset.handle)));
        });
        root.querySelectorAll('[data-m360v4-saved-count]').forEach((count) => {
          count.textContent = String(memory.length);
          count.hidden = memory.length === 0;
        });
        if (dialog?.open) renderSaved();
        syncSelection();
      };

      const filterCards = (notify = true) => {
        const value = priceInput?.value?.trim() || '';
        const parsed = Number(value);
        const ceiling = value !== '' && Number.isFinite(parsed) && parsed >= 0 ? parsed : Infinity;
        const onlyAvailable = Boolean(availabilityInput?.checked);
        const visibleHandles = new Set();
        root.querySelectorAll('[data-m360v4-card]').forEach((card) => {
          const price = Number(card.dataset.price);
          const priceMatches = !Number.isFinite(price) || price <= ceiling;
          card.hidden = !priceMatches || (onlyAvailable && card.dataset.available !== 'true');
          if (!card.hidden) visibleHandles.add(card.dataset.handle);
        });
        root.querySelectorAll('[data-m360v4-product-group]').forEach((group) => {
          const empty = group.querySelector('[data-m360v4-filter-empty]');
          const cards = Array.from(group.querySelectorAll('[data-m360v4-card]'));
          if (empty) empty.hidden = !cards.length || cards.some((card) => !card.hidden);
        });
        if (priceOutput) {
          priceOutput.textContent = Number.isFinite(ceiling) ? priceFormatter.format(ceiling / 100) : label('allPrices');
        }
        const resultMessage = label('filterResults').replace('{count}', String(visibleHandles.size));
        root.querySelectorAll('[data-m360v4-filter-results]').forEach((node) => {
          node.textContent = resultMessage;
        });
        if (notify) announce(resultMessage);
      };

      const closeSaved = () => {
        if (!dialog) return;
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        if (lastOpener?.isConnected) lastOpener.focus();
      };

      root.addEventListener('click', (event) => {
        recordOpened(event);
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button.matches('[data-m360v4-save]')) {
          const saved = readSaved();
          const existing = saved.find((item) => item.handle === button.dataset.handle);
          if (existing) {
            writeSaved(saved.filter((item) => item.handle !== existing.handle));
            announce(`${existing.title}: ${label('savedRemoved')}`);
          } else if (saved.length < 100) {
            const [item] = cleanItems([button.dataset]);
            if (item) {
              writeSaved([...saved, item]);
              announce(`${item.title}: ${label('savedAdded')}`);
            }
          } else {
            announce(label('savedLimit'));
          }
        } else if (button.matches('[data-m360v4-open-saved]') && dialog) {
          readSaved();
          renderSaved();
          sync();
          lastOpener = button;
          if (!dialog.open) {
            if (typeof dialog.showModal === 'function') dialog.showModal();
            else dialog.setAttribute('open', '');
          }
        } else if (button.matches('[data-m360v4-close-saved]')) {
          closeSaved();
        } else if (button.matches('[data-m360v4-remove-saved]')) {
          const buttons = Array.from(savedList.querySelectorAll('[data-m360v4-remove-saved]'));
          const position = buttons.indexOf(button);
          const saved = readSaved();
          const removed = saved.find((item) => item.handle === button.dataset.m360v4RemoveSaved);
          writeSaved(saved.filter((item) => item.handle !== button.dataset.m360v4RemoveSaved));
          const remaining = savedList.querySelectorAll('[data-m360v4-remove-saved]');
          const next = remaining[Math.min(position, remaining.length - 1)] || dialog.querySelector('[data-m360v4-close-saved]');
          next?.focus();
          if (removed) announce(`${removed.title}: ${label('savedRemoved')}`);
        } else if (button.matches('[data-m360v4-open-compare]') && compareDialog) {
          readSelection();
          syncSelection();
          renderComparison();
          compareOpener = button;
          if (!compareDialog.open) {
            if (typeof compareDialog.showModal === 'function') compareDialog.showModal();
            else compareDialog.setAttribute('open', '');
          }
        } else if (button.matches('[data-m360v4-close-compare]')) {
          closeCompare();
        } else if (button.matches('[data-m360v4-remove-compare]')) {
          const handle = button.dataset.m360v4RemoveCompare;
          writeSelection(compareKey, compareMemory.filter((saved) => saved !== handle));
          compareChoices?.querySelectorAll('[data-m360v4-compare-handle]').forEach((input) => {
            if (input.dataset.m360v4CompareHandle === handle) input.focus();
          });
        } else if (button.matches('[data-m360v4-clear-recent]')) {
          writeSelection(recentKey, []);
          selection.querySelector('.m360v4-recent>summary')?.focus();
        } else if (button.matches('[data-m360v4-reset-filters]')) {
          if (priceInput) priceInput.value = priceInput.type === 'range' ? priceInput.max : '';
          if (availabilityInput) availabilityInput.checked = false;
          filterCards();
        }
      }, eventOptions);

      root.addEventListener('auxclick', (event) => {
        if (event.button === 1) recordOpened(event);
      }, eventOptions);
      compareChoices?.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !input.matches('[data-m360v4-compare-handle]')) return;
        const handle = input.dataset.m360v4CompareHandle;
        const selected = selectedProducts().map((item) => item.handle);
        if (input.checked && selected.length >= 4) {
          input.checked = false;
          compareStatus.textContent = selectionLabel('compareLimit');
          return;
        }
        writeSelection(compareKey, input.checked ? [...selected, handle] : selected.filter((saved) => saved !== handle));
      }, eventOptions);
      compareDialog?.addEventListener('click', (event) => {
        if (event.target !== compareDialog) return;
        const bounds = compareDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeCompare();
      }, eventOptions);
      compareDialog?.addEventListener('close', () => {
        if (compareOpener?.isConnected) compareOpener.focus();
      }, eventOptions);

      priceInput?.addEventListener('input', () => filterCards(), eventOptions);
      availabilityInput?.addEventListener('change', () => filterCards(), eventOptions);
      dialog?.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeSaved();
      }, eventOptions);
      dialog?.addEventListener('close', () => {
        if (lastOpener?.isConnected) lastOpener.focus();
      }, eventOptions);

      controllers.set(root, {
        sync,
        dispose() {
          clearTimeout(announcementTimer);
          if (compareDialog?.open) closeCompare();
          aborter.abort();
          initialized.delete(root);
        }
      });
      sync();
      filterCards(false);
    };

    const initializeAll = () => {
      readSaved();
      readSelection();
      document.querySelectorAll('.m360v4').forEach(initialize);
      syncAll();
    };
    window[runtimeKey] = initializeAll;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
    document.addEventListener('shopify:section:unload', (event) => {
      for (const [root, controller] of controllers) {
        if (event.target.contains(root)) {
          controller.dispose();
          controllers.delete(root);
        }
      }
    });
    window.addEventListener('storage', (event) => {
      if (![storageKey, recentKey, compareKey, null].includes(event.key)) return;
      if (!storageAvailable) return;
      readSaved();
      readSelection();
      syncAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
